import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  GET_GROUPED_BY_STATUS_APPROVER,
  GET_PROVIDER_CONTRACT_LIST_APPROVER,
  GET_PROVIDER_CONTRACT_SUB_LIST_APPROVER,
} from "src/api-setup/api-endpoints";
import { POSTAPI } from "src/api-setup/api-helper";
import { USER_GRID_DEFAULT_PAGE_SIZE } from "src/constants/grid";
import { getTenantCookieData, getUserCredential } from "src/lib/cookies";
import { setNewMessage } from "src/redux/actions/setting-actions";
import { GridColumnDataMapper } from "src/utils/utils";
import { API_CONSTANTS, statusList } from "./constants";

const initialDataState = {
  skip: 0,
  take: USER_GRID_DEFAULT_PAGE_SIZE,
};
let defaultItem = {
  text: USER_GRID_DEFAULT_PAGE_SIZE,
  id: 2,
};

const useApproverDashboardApi = () => {
  const cookiesData = getUserCredential();

  const header = {
    "x-access-token": cookiesData.secretToken,
  };

  const dispatch = useDispatch();

  const [data, setData] = React.useState([]);
  const [columns, setColumns] = React.useState([]);
  const [dataCount, setDataCount] = React.useState(0);

  const [isRefreshLoading, setIsRefreshLoading] = useState(false);
  const [isAPICalling, setAPICallingState] = useState(false);
  const [isContractLoading, setISContractLoading] = useState(false);
  const [isPendingRequestsLoading, setIsPendingRequestsLoading] = useState(false);
  const [statusCount, setStatusCount] = useState([]);
  const [providerSubColumn, setProviderSubColumn] = useState([]);

  const columnXml = `{"resultset":{"metadata":[{"field":[{"$":{"name":"temp.provider_name","label":"PROVIDER NAME","type":"string","filterable":"1"},"format":[""]},{"$":{"name":"temp.contract_type","label":"CONTRACT TYPE","type":"string","filterable":"1"},"format":[""]},{"$":{"name":"temp.approval_rate","label":"APPROVED","type":"number","filterable":"0"},"format":[""]},{"$":{"name":"temp.pending_rate","label":"PENDING","type":"number","filterable":"0"},"format":[""]},{"$":{"name":"temp.rejected_rate","label":"REJECTED","type":"number","filterable":"0"},"format":[""]},{"$":{"name":"temp.total_earnings","label":"TOTAL EARNINGS","type":"number","filterable":"0"},"format":[""]}]}]}}`;

  const providerSubColXml = `{"resultset":{"metadata":[{"field":[{"$":{"name":"temp.specialty_name","label":"SPECIALITY NAME","type":"string","filterable":"0"},"format":[""]},{"$":{"name":"temp.position_type_name","label":"POSITION TYPE","type":"string","filterable":"0"},"format":[""]},{"$":{"name":"temp.contract_name","label":"CONTRACT NAME","type":"string","filterable":"0"},"format":[""]},{"$":{"name":"temp.approval_rate","label":"APPROVED","type":"number","filterable":"0"},"format":[""]},{"$":{"name":"temp.pending_rate","label":"PENDING","type":"number","filterable":"0"},"format":[""]},{"$":{"name":"temp.rejected_rate","label":"REJECTED","type":"number","filterable":"0"},"format":[""]},{"$":{"name":"temp.total_earnings","label":"TOTAL EARNINGS","type":"number","filterable":"0"},"format":[""]}]}]}}`;

  // Get status count api
  const fetchGroupStatusForApprover = (payload) => {
    setIsPendingRequestsLoading(true);
    return new Promise(function (resolve, reject) {
      POSTAPI(false, GET_GROUPED_BY_STATUS_APPROVER, null, header, payload, dispatch)
        .then((res) => {
          if (res) {
            const overviewArr = res.data.row_result || [];

            const statusData = overviewArr.map((item) => ({
              approval_status: statusList[item.approval_status].status || "Unknown",
              task_count: item.task_count,
              color: statusList[item.approval_status].color || "",
              status_Const: item.approval_status,
            }));
            setStatusCount(statusData);
            setIsPendingRequestsLoading(false);
            resolve(statusData);
          }
        })
        .then((res) => {
          return res;
        })
        .catch((err) => {
          console.log("ERRe", err);
        })
        .finally(() => {
          setIsPendingRequestsLoading(false);
        });
    });
  };

  // Get Provier list api
  const fetchGetProvidersForApprover = (payload) => {
    setAPICallingState(true);
    return new Promise(function (resolve, reject) {
      POSTAPI(false, GET_PROVIDER_CONTRACT_LIST_APPROVER, null, header, payload, dispatch)
        .then((res) => {
          if (res) {
            if (res.data.out_parameters.out_ret_code > 0) {
              setIsRefreshLoading(true);
            }
            setIsRefreshLoading(true);
            const flattenData = res.data.row_result || [];
            if (payload.in_load_type === "grid-reload") {
              const columData = GridColumnDataMapper(columnXml)?.map((obj) => {
                return { ...obj, width: 150 };
              });
              columData.map((cItem, idx) => {
                cItem.minWidth = 210;
                cItem.show = true;
                cItem.selected = false;
                cItem.rowId = idx;
                return 0;
              });
              setColumns(columData);
            }
            const finalData = flattenData.map((item, idx) => ({ ...item, rowId: idx }));
            setData(finalData);
            setDataCount(finalData.length);
            setIsRefreshLoading(false);
            resolve(finalData);
          }
        })
        .then((res) => {
          return res;
        })
        .catch((err) => {
          console.log("ERRe", err);
        })
        .finally(() => {
          setAPICallingState(false);
        });
    });
  };

  const fetchGetContractForApprover = (payload) => {
    setISContractLoading(true);
    return new Promise(function (resolve, reject) {
      POSTAPI(false, GET_PROVIDER_CONTRACT_SUB_LIST_APPROVER, null, header, payload, dispatch)
        .then((res) => {
          if (res) {
            setIsRefreshLoading(true);
            const flattenData = res.data.row_result || [];
            if (payload.in_load_type === "grid-reload") {
              const columData = GridColumnDataMapper(providerSubColXml)?.map((obj) => {
                return { ...obj, width: 150 };
              });

              setProviderSubColumn(columData);
            }
            const finalData = flattenData.map((item, idx) => ({ ...item, rowId: idx }));
            resolve(finalData);
            setISContractLoading(false);
          }
        })
        .then((res) => {
          return res;
        })
        .catch((err) => {
          console.log("ERRe", err);
        })
        .finally(() => {
          setISContractLoading(false);
        });
    });
  };

  return [
    {
      data,
      columns,
      dataCount,
      isPendingRequestsLoading,
      statusCount,
      isRefreshLoading,
      isAPICalling,
      setData,
      setAPICallingState,
      isContractLoading,
      providerSubColumn,
      setProviderSubColumn,
    },
    { fetchGroupStatusForApprover, fetchGetProvidersForApprover, fetchGetContractForApprover },
  ];
};

export default useApproverDashboardApi;
